'use strict';

var angularModule = angular.module('t2g.common.data-access.subscription', [
  'ngResource',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.sessionStorage').name,
  require('t2g.common.services.userSessionService').name,
]);

module.exports = angularModule;

angularModule.factory('SubscriptionResource', function($resource, settings) {
  var resourceUrl =
    settings.apiBase + '/api/v2/subscription/:subResource1/:subResource2/:subResource3';

  var resource = $resource(
    resourceUrl,
    {},
    {
      getPrice: { method: 'GET', isArray: false, params: { subResource1: 'prices' } },
      getCustomerToken: {
        method: 'GET',
        isArray: false,
        params: { subResource1: 'billwerk', subResource2: 'customerToken' },
      },
      upDownGrade: { method: 'POST', isArray: false },
    },
  );

  return resource;
});

angularModule.factory('SubscriptionDA', function(
  localStorageService,
  settings,
  SubscriptionResource,
) {
  return {
    get: get,
    getPrice: getPrice,
    getCustomerToken: getCustomerToken,
    upDownGrade: upDownGrade,
  };

  function get() {
    return SubscriptionResource.get().$promise.then(function(response) {
      var subscription = response.subscription;
      var onlyBasicFunctions = false;

      if (subscription.empty && subscription.trialDaysLeft === 0) {
        onlyBasicFunctions = true;
      } else {
        onlyBasicFunctions = subscription.package === 'basic';
      }

      subscription.onlyBasicFunctions = onlyBasicFunctions;

      return subscription;
    });
  }

  function getPrice(countryCode, employees) {
    return SubscriptionResource.getPrice({
      subResource2: countryCode,
      subResource3: employees,
    }).$promise.then(function(response) {
      return response.prices;
    });
  }

  function getCustomerToken() {
    return SubscriptionResource.getCustomerToken().$promise.then(function(response) {
      return response.customerToken;
    });
  }

  function upDownGrade(upDownGradeDate) {
    return SubscriptionResource.upDownGrade(upDownGradeDate).$promise.then(function(response) {
      return response.upDownGrade;
    });
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/subscription.js